import React, { useState } from 'react';

import { ContentPopup } from 'components/ContentPopup.jsx';
import ChangeTierModal from 'components/payment/ChangeTierModal.jsx';

// "Change plan" on a subscription card: pick a tier, then confirm it in the same preview
// modal /pricing uses. The subscriber gets to the switch from the page where their
// subscription already lives, instead of having to find the pricing page and work out which
// card is theirs.
//
// `options` comes from the server (ChargesController#tier_change_options) already filtered
// to the tiers this subscription may move to, each carrying its direction — the card never
// decides eligibility for itself, and so can never offer a switch the server would refuse.
const ChangePlanButton = ({ options, currentPlanDescription, stripeId }) => {
  const [chooserOpen, setChooserOpen] = useState(false);
  const [target, setTarget] = useState(null);

  if (!options || options.length === 0) {
    return null;
  }

  const chooser = (
    <div className="change-plan-chooser">
      <h3 className="change-plan-chooser-title">{t('payment.change_plan_title')}</h3>
      {currentPlanDescription && (
        <p className="change-plan-chooser-current">
          {t('payment.change_plan_current_line').replace('%{plan}', currentPlanDescription)}
        </p>
      )}
      <ul className="change-plan-chooser-options">
        {options.map((option) => (
          <li key={option.tier} className="change-plan-chooser-option">
            <a
              className="btn subscription-card-action-primary change-plan-chooser-option-cta"
              href="#"
              onClick={(event) => { event.preventDefault(); setTarget(option); }}
            >
              {(option.direction === 'downgrade'
                ? t('payment.change_tier_downgrade_cta')
                : t('payment.change_tier_upgrade_cta')
              ).replace('%{tier}', option.name)}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <span>
      <a
        className="btn subscription-card-action-secondary"
        href="#"
        onClick={(event) => { event.preventDefault(); setChooserOpen(true); }}
      >
        {t('payment.change_plan_cta')}
      </a>

      {chooserOpen && !target && (
        <ContentPopup
          autoOpen
          notWide
          content={chooser}
          beforeClose={() => setChooserOpen(false)}
        />
      )}

      {target && (
        <ChangeTierModal
          targetTier={target.tier}
          targetTierName={target.name}
          direction={target.direction}
          stripeId={stripeId}
          onClose={() => { setTarget(null); setChooserOpen(false); }}
          // Reload rather than refetch the card: a tier change also moves the plan named in
          // the subscriptions table below it, and /pricing's own change reloads too. A
          // downgrade deliberately leaves the local plan on the current tier until the
          // period boundary, so the reload correctly still shows the tier they paid for.
          onSuccess={() => window.location.reload()}
        />
      )}
    </span>
  );
};

export default ChangePlanButton;
